'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

exports.default = _react.PropTypes.shape({
  getHelper: _react.PropTypes.func.isRequired,
  getState: _react.PropTypes.func.isRequired,
  subscribe: _react.PropTypes.func.isRequired
});


//////////////////
// WEBPACK FOOTER
// ./~/react-algoliasearch-helper/src/storeShape.js
// module id = 1484
// module chunks = 0